import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import Background from "_assets/AdDirectBackground.svg";
import BackgroundMobile from "_assets/AdDirectBackgroundMobile.svg";
import LinkMarketingPages from "_components/LinkMarketingPages";

const useStyles = makeStyles(() => ({
   container: {
      backgroundColor: "#9DFF7B",
      backgroundImage: `url(${Background})`,
      boxShadow: "0px 4px 24px -1px rgba(26, 26, 26, 0.08)",
      borderRadius: "20px",
      backdropFilter: "blur(15px)",
      margin: "30px auto 77px",
      width: "90vw",
      backgroundSize: "100%",
      backgroundRepeat: "no-repeat",
      "@media (max-width: 600px)": {
         backgroundImage: `url(${BackgroundMobile})`,
         paddingLeft: "24px",
         paddingRight: "24px",
         width: "calc(90vw - 48px)",
         margin: "81px auto 30px",
      },
   },
   title: {
      fontFamily: "dr-extrabold, Arial, Helvetica, sans-serif",
      fontSize: "4rem",
      lineHeight: "93.75%",
      textAlign: "center",
      paddingTop: "28px",
      maxWidth: "560px",
      margin: "0 auto 22px",
      color: "black",
      "@media (max-width: 600px)": {
         fontSize: "3rem",
         lineHeight: "95%",
         textAlign: "left",
         marginLeft: "0px",
         paddingTop: "35px",
      },
   },
   description: {
      fontSize: "19px",
      lineHeight: "28px",
      textAlign: "center",
      maxWidth: "560px",
      margin: "0 auto",
      color: "black",
      "@media (max-width: 600px)": {
         textAlign: "left",
         marginLeft: "0px",
      },
   },
   buttonContainer: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      padding: "36px 0 75px",
      gap: "10px",
      "@media (max-width: 600px)": {
         padding: "64px 0 85px",
         justifyContent: "flex-start",
      },
   },
   svgWrapper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      paddingTop: "44px",
      "@media (max-width: 600px)": {
         paddingTop: "0px",
         // Negative margin half its height to center it
         "& svg": {
            marginTop: "-33px",
         },
      },
   },
}));

/**
 * Time To Get To Work
 * @returns {React.Element} Time To Get To Work component
 */
const AdDirect = () => {
   const classes = useStyles();

   return (
      <div className={classes.container}>
         <div className={classes.svgWrapper}>
            <svg
               width="180"
               height="67"
               viewBox="0 0 180 67"
               fill="none"
               xmlns="http://www.w3.org/2000/svg"
            >
               <rect
                  y="0.636719"
                  width="180"
                  height="65.4545"
                  rx="32.7273"
                  fill="black"
               />
               <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M45.9496 15H52.6121V47.7878H45.9496V46.455C44.2196 47.6432 42.1372 48.2589 39.806 48.2589C36.0943 48.2589 32.8857 46.9444 30.6035 44.6587C28.3211 42.3728 27 39.15 27 35.3979C27 27.8991 32.3392 22.537 39.806 22.537C42.1447 22.537 44.2251 23.189 45.9496 24.3574V15ZM47.1711 16.2267V26.9449L46.1599 26.063C44.4919 24.6082 42.3369 23.7637 39.806 23.7637C33.0138 23.7637 28.2215 28.5765 28.2215 35.3979C28.2215 38.8531 29.4332 41.7541 31.4661 43.7901C33.4992 45.8264 36.3882 47.0322 39.806 47.0322C42.3445 47.0322 44.4935 46.2302 46.1531 44.7389L47.1711 43.8242V46.5611H51.3906V16.2267H47.1711ZM56.9255 15H63.588V21.4084H56.9255V15ZM58.147 16.2267V20.1817H62.3665V16.2267H58.147ZM139.208 15H145.777V23.008H153V29.228H145.777V38.8367C145.777 39.8458 146.032 40.4984 146.44 40.9032C146.848 41.3092 147.511 41.5679 148.543 41.5679H153V47.7878H148.168C145.259 47.7878 142.989 47.0572 141.45 45.5051C139.911 43.9536 139.208 41.6856 139.208 38.8367V29.228H136.628V23.008H139.208V15ZM140.429 16.2267V24.2348H137.85V28.0013H140.429V38.8367C140.429 41.4992 141.086 43.4001 142.315 44.6396C143.544 45.8786 145.448 46.5611 148.168 46.5611H151.779V42.7946H148.543C147.323 42.7946 146.298 42.4879 145.581 41.7752C144.862 41.0613 144.555 40.0415 144.555 38.8367V28.0013H151.779V24.2348H144.555V16.2267H140.429ZM82.5977 35.3979C82.5977 27.8991 87.9369 22.537 95.4037 22.537C102.871 22.537 108.21 27.8991 108.21 35.3979C108.21 36.1531 108.11 36.8991 108.016 37.5573L107.941 38.084H89.5447C89.94 39.286 90.5904 40.2446 91.4375 40.9331C92.4528 41.7583 93.7898 42.2273 95.4037 42.2273C97.4146 42.2273 99.0457 41.6926 100.057 40.1891L100.239 39.9191H107.384L107.153 40.7059C105.739 45.5245 100.831 48.2589 95.4037 48.2589C91.692 48.2589 88.4834 46.9444 86.2012 44.6587C83.9188 42.3728 82.5977 39.15 82.5977 35.3979ZM95.4037 23.7637C88.6115 23.7637 83.8192 28.5765 83.8192 35.3979C83.8192 38.8531 85.0309 41.7541 87.0638 43.7901C89.0969 45.8264 91.9859 47.0322 95.4037 47.0322C100.152 47.0322 104.207 44.8109 105.706 41.1459H100.876C99.5363 42.9129 97.5106 43.4541 95.4037 43.4541C93.5467 43.4541 91.9287 42.9103 90.6691 41.8866C89.4103 40.8636 88.5485 39.3929 88.1474 37.6054L87.9795 36.8572H106.879C106.941 36.37 106.988 35.8815 106.988 35.3979C106.988 28.5765 102.196 23.7637 95.4037 23.7637ZM110.16 35.3979C110.16 27.8991 115.499 22.537 122.966 22.537C129.834 22.537 134.985 27.0974 135.675 33.8277L135.744 34.5039H129.105L129.023 33.9862C128.761 32.32 128.049 31.0221 127.024 30.1402C126 29.2584 124.622 28.7569 122.966 28.7569C121.049 28.7569 119.504 29.4207 118.437 30.5501C117.367 31.6826 116.729 33.3354 116.729 35.3979C116.729 37.4604 117.367 39.1133 118.437 40.2457C119.504 41.3752 121.049 42.0389 122.966 42.0389C124.622 42.0389 126 41.5375 127.024 40.6556C128.049 39.7737 128.761 38.4758 129.023 36.8097L129.105 36.292H135.744L135.675 36.9681C134.985 43.697 129.883 48.2589 122.966 48.2589C119.254 48.2589 116.046 46.9444 113.763 44.6587C111.481 42.3728 110.16 39.15 110.16 35.3979ZM122.966 23.7637C116.174 23.7637 111.381 28.5765 111.381 35.3979C111.381 38.8531 112.593 41.7541 114.626 43.7901C116.659 45.8264 119.548 47.0322 122.966 47.0322C129.039 47.0322 133.492 43.2288 134.373 37.5187H130.134C129.772 39.1997 128.976 40.591 127.819 41.587C126.545 42.6837 124.874 43.2656 122.966 43.2656C120.756 43.2656 118.876 42.4926 117.551 41.0901C116.229 39.6906 115.507 37.7163 115.507 35.3979C115.507 33.0796 116.229 31.1052 117.551 29.7058C118.876 28.3032 120.756 27.5302 122.966 27.5302C124.874 27.5302 126.545 28.1122 127.819 29.2088C128.976 30.2049 129.772 31.5961 130.134 33.2772H134.373C133.488 27.5684 128.996 23.7637 122.966 23.7637ZM81.6663 22.6864V29.6393L74.5368 32.5598V47.7878H67.8743V23.008H74.5368V25.7954L81.6663 22.6864ZM56.9255 23.008H63.588V47.7878H56.9255V23.008ZM58.147 24.2348V46.5611H62.3665V24.2348H58.147ZM69.0958 24.2348V46.5611H73.3153V31.7354L80.4448 28.8148V24.5564L73.3153 27.6654V24.2348H69.0958ZM89.7338 32.2408H100.992C100.095 29.9226 98.0858 28.5685 95.4037 28.5685C92.6809 28.5685 90.6654 29.9217 89.7338 32.2408ZM88.2953 32.6905C89.2143 29.3578 91.8511 27.3418 95.4037 27.3418C98.9105 27.3418 101.551 29.36 102.421 32.699L102.621 33.4676H88.0811L88.2953 32.6905ZM35.2772 30.5501C34.2072 31.6826 33.5687 33.3354 33.5687 35.3979C33.5687 37.4604 34.2072 39.1133 35.2772 40.2457C36.3442 41.3752 37.8888 42.0389 39.806 42.0389C41.6974 42.0389 43.2174 41.3769 44.2673 40.2491C45.321 39.1172 45.9496 37.4634 45.9496 35.3979C45.9496 33.3325 45.321 31.6787 44.2673 30.5468C43.2174 29.4189 41.6974 28.7569 39.806 28.7569C37.8888 28.7569 36.3442 29.4207 35.2772 30.5501ZM34.3911 29.7058C35.7161 28.3032 37.5957 27.5302 39.806 27.5302C41.9954 27.5302 43.8526 28.305 45.1596 29.7091C46.4629 31.1091 47.1711 33.0825 47.1711 35.3979C47.1711 37.7134 46.4629 39.6867 45.1596 41.0868C43.8526 42.4909 41.9954 43.2656 39.806 43.2656C37.5957 43.2656 35.7161 42.4926 34.3911 41.0901C33.0689 39.6906 32.3472 37.7163 32.3472 35.3979C32.3472 33.0796 33.0689 31.1052 34.3911 29.7058Z"
                  fill="#9EFF7B"
               />
            </svg>
         </div>

         <h1 className={classes.title}>
            Start making money doing what you love
         </h1>
         <div className={classes.description}>
            Sell your music, create custom merchandise and build your fan base
            with memberships; all on Aux&apos;s sister site Direct.
         </div>
         <div className={classes.buttonContainer}>
            <LinkMarketingPages
               to="https://direct.app?utm_source=own+sites&utm_medium=website&utm_campaign=aux+direct+cross"
               linkText="Join now for free"
               color="black"
               textSize={{
                  fontSize: "21px",
                  lineHeight: "150%",
                  fontWeight: 600,
               }}
               target="_blank"
               external
            />
         </div>
      </div>
   );
};

export default AdDirect;
